import Details from '../Details'
import Plain from '../../../../components/helpers/Plain'

export const tabsOptions = [
  { name: 'details', Component: Details },
  { name: 'questions', Component: Plain }
]
